import { useLocation } from 'react-router-dom';

import { Navigate, NavigateProps } from './Navigate';

type Props = {
  prefix: string;
} & Omit<NavigateProps, 'to'>;

export const NavigateWithPathnamePrefix = ({ prefix, ...rest }: Props) => {
  const location = useLocation();

  return <Navigate to={`${prefix}${location.pathname}`} {...rest} />;
};
